import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

import PremiumBackground from '@/assets/images/bg_EQUINET_Premium.jpg';
import EquinetLogo from '@/assets/images/equinet-logo.png';
import { COLOR } from '@/theme/colors';

const PremiumPageHeader: React.FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '15rem',
                backgroundColor: 'transparent',
                gap: 2,
                backgroundImage: `url(${PremiumBackground})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                padding: '0',
            }}
        >
            <Box
                component="img"
                src={EquinetLogo}
                alt="Equinet Icon"
                sx={{
                    width: 60,
                    height: 60,
                }}
            />
            <Typography
                variant="h4"
                color={COLOR.white}
                fontWeight={700}
                fontSize={24}
                sx={{ textShadow: '1px 1px 6px black' }}
            >
                {t('PremiumPage:header:title')}
            </Typography>
        </Box>
    );
};

export default PremiumPageHeader;
